module.exports = __webpack_public_path__ + "img/capa1.925f7e7d.png";